<template>
    <section class="c-pwa-types">
        <div
            v-if="pwaTypes"
            class="c-pwa-types--loaded"
        >
            <y-discover-power
                :content="pwaTypes"
                :custom-btn="customBtn"
                remove-banner
                show-synopsis
                :button-class="buttonClass"
            />
        </div>
    </section>
</template>

<script >
    import { isLink } from '@/helpers/helpers';
    import YDiscoverPower from '@modules/home/components/DiscoverPower/Index';

    export default {
        name: 'PwaTypes',

        components: {
            YDiscoverPower,
        },

        /**
         *
         * @inheritDoc
         */
        props: {
            pwaTypes   : Object,
            customBtn  : Object,
            buttonClass: String,
        },

        /**
         *
         * @inheritDoc
         */
        methods: {
            isLink,
        },
    };

</script>

<style lang="scss" src="./index.scss"/>
